import { render, staticRenderFns } from "./reloadPage.vue?vue&type=template&id=ec8a842c&"
import script from "./reloadPage.vue?vue&type=script&lang=js&"
export * from "./reloadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports